export default __webpack_public_path__ + "static/media/accountability.92f9f6b3.jpg";